import React from "react";
import { Box, Typography } from "@mui/material";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";

const RaceInfo = ({ raceData, isMediumScreen, totalBets }) => {
  const { raceName, raceTime, runnersInfo } = raceData;
  return (
    <>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography
          color="white"
          fontSize={
            isMediumScreen ? fontSizes.heading2 : fontSizes.superHeading3
          }
          fontFamily="MontserratBold"
          textAlign={"left"}
        >
          {raceName}
        </Typography>
        <Typography
          color={darkColors.buttonTop}
          fontSize={
            isMediumScreen ? fontSizes.heading3 : fontSizes.superHeading5
          }
          fontFamily="MontserratBold"
          textAlign={"right"}
          //   lineHeight={2.4}
        >
          {raceTime}
        </Typography>
      </Box>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography
          color="#BEBEBE"
          fontSize={isMediumScreen ? fontSizes.body : fontSizes.heading3}
          textAlign={"left"}
        >
          {runnersInfo} Runners
        </Typography>
        <Typography
          color="white"
          fontSize={isMediumScreen ? fontSizes.heading3 : fontSizes.heading2}
          fontFamily="MontserratBold"
          textAlign={"right"}
          mt={isMediumScreen ? -0.7 : -1.5}
        >
          {totalBets} Bets
        </Typography>
      </Box>
    </>
  );
};

export default RaceInfo;
